export const OIDC_LOGIN_DEFAULT = "oidc.login.default"